import { CierreCaja } from "./CierreCaja";

export class RetiroEfectivo{
    id: string;
    cierresCajasIds: string[];
    responsable: string;
    fechaRetiro: string;
    linkRecibo: string;
    cierresCajas: CierreCaja[];
}